import 'core-js/fn/promise/finally'; // ensure promise.finally is available
import Vue from 'vue';
import '@/components/_globals';
import rootStore, { instance as store } from '@/state/store';
import router from '@/router';
import { sync } from 'vuex-router-sync';
import Auth from '@okta/okta-vue';
import App from '@/App.vue';
import moment from 'moment';

// Register any global vue components
import vClickOutside from 'v-click-outside';
Vue.use(vClickOutside);

import Vuelidate from 'vuelidate';
Vue.use(Vuelidate)

import VueCookies from 'vue-cookies';
Vue.use(VueCookies);

// Sync router with store
sync(store, router);

// Immediately set 'loading' message
rootStore.commitAddMessage({
	id: 'loading-config',
	type: 'info',
	message: 'Loading config...',
	timeout: 0,
});

// Start loading app config
const configPromise = rootStore.dispatchGetConfig('/config.json')
	.then((config) => {
		Vue.use(Auth, {
			...config.sso,
			scope: 'openid profile partnerauth channel',
		});
	})
	.catch((e) => {
		console.error('Unable to auth - missing config'); // tslint:disable-line:no-console
		Vue.use(Auth, {
			issuer: ' ',
			client_id: ' ',
			redirect_uri: ' ',
			scope: 'openid profile',
		});
		throw e;
	})
	.finally(() => {
		rootStore.commitRemoveMessage('loading-config');
	});

Vue.filter('formatDate', function(value: string) {
	if (value) {
		value = value.replace(/:0{3,7}/,' ');
		return moment(String(value)).format('M/D/YYYY hh:mm A');
	}
});

Vue.filter('toCurrency', function (value : number | string) {
	if (typeof value === "string") {
		value = parseFloat(value);
	}
	if (typeof value !== "number") {
		return value;
	}
	var formatter = new Intl.NumberFormat('en-US', {
		style: 'currency',
		currency: 'USD',
		minimumFractionDigits: 2
	});
	return formatter.format(value);
});

Vue.filter('generalizeCredit', function (value : string) {
	switch (value) {
		case '625+': return 'Pass';
		case '600 - 624': return 'Mid';
		case '550 - 599': return 'Failed Subprime';
		case '549-': return 'Failed';
	}

	return value;
});

Vue.filter('phone', function (phone : string) {
	if (typeof phone !== "string") {
		return phone;
	}
	return phone.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
});

// Don't warn about using the dev version of Vue in development
Vue.config.productionTip = process.env.NODE_ENV === 'production';

// Let's do this!
new Vue({
	router,
	store,
	render: h => h(App, {
		props: {
			configPromise,
		},
	}),
}).$mount('#app');
